import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
function PriceRow({ title, amount }) {
    return (_jsx("div", { className: "price-row-wrapper", children: _jsxs("div", { className: "row", children: [_jsx("span", { className: "title", children: title }), _jsxs("span", { className: "amount", children: [amount, ",-"] })] }) }));
}
PriceRow.propTypes = {
    title: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
};
export default PriceRow;
